const gray = {
  50: 'rgba(250, 250, 250, 1)',
  100: 'rgba(247, 247, 247, 1)',
  200: 'rgba(227, 227, 227, 1)',
  300: 'rgba(202, 202, 202, 1)',
  400: 'rgba(100, 100, 100, 1)',
};

const blue = {
  50: 'rgba(235, 248, 255, 1)',
  100: 'rgba(128, 155, 186, 1)',
  200: 'rgba(100, 182, 247, 1)',
  300: 'rgba(10, 148, 217, 1)',
  400: 'rgba(23, 105, 170, 1)',
  500: 'rgba(8, 86, 139, 1)',
  600: 'rgba(21, 62, 117, 1)',
};

const orange = {
  50: 'rgba(255, 250, 240, 1)',
  100: 'rgba(254, 235, 200, 1)',
  200: 'rgba(251, 211, 141, 1)',
  300: 'rgba(237, 137, 54, 1)',
  400: 'rgba(237, 108, 2, 1)',
  500: 'rgba(166, 76, 1, 1)',
  600: 'rgba(101, 43, 25, 1)',
};

const green = {
  50: 'rgba(240, 255, 244, 1)',
  100: 'rgba(198, 246, 213, 1)',
  200: 'rgba(123, 198, 126, 1)',
  300: 'rgba(47, 133, 90, 1)',
  400: 'rgba(34, 84, 61, 1)',
};

const red = {
  50: 'rgba(254, 215, 215, 1)',
  100: 'rgba(228, 95, 95, 1)',
  200: 'rgba(229, 62, 62, 1)',
  300: 'rgba(171, 47, 38, 1)',
  400: 'rgba(130, 39, 39, 1)',
};

const lightPalette = {
  mode: 'light',
  primary: {
    main: 'rgba(8, 86, 139, 1)',
    light: 'rgba(57, 119, 162, 1)',
    dark: 'rgba(5, 60, 97, 1)',
    contrastText: 'rgba(255, 255, 255, 1)',
  },
  secondary: {
    main: 'rgba(0, 128, 123, 1)',
    light: 'rgba(51, 153, 149, 1)',
    dark: 'rgba(0, 89, 86, 1)',
    contrastText: 'rgba(255, 255, 255, 1)',
  },
  info: {
    main: 'rgba(2, 136, 209, 1)',
    light: 'rgba(3, 169, 244, 1)',
    dark: 'rgba(1, 87, 155, 1)',
    contrastText: 'rgba(255, 255, 255, 1)',
  },
  success: {
    main: 'rgba(46, 125, 50, 1)',
    light: 'rgba(76, 175, 80, 1)',
    dark: 'rgba(27, 94, 32, 1)',
    contrastText: 'rgba(255, 255, 255, 1)',
  },
  warning: {
    main: 'rgba(237, 108, 2, 1)',
    light: 'rgba(255, 152, 0, 1)',
    dark: 'rgba(230, 81, 0, 1)',
    contrastText: 'rgba(255, 255, 255, 1)',
  },
  error: {
    main: 'rgba(211, 47, 47, 1)',
    light: 'rgba(239, 83, 80, 1)',
    dark: 'rgba(198, 40, 40, 1)',
    contrastText: 'rgba(255, 255, 255, 1)',
  },
  background: {
    paper: 'rgba(255, 255, 255, 1)',
    default: 'rgba(250, 250, 250, 1)',
  },
  variant: {
    ratingActive: 'rgba(255, 180, 0, 1)',
    snackbar: 'rgba(0, 0, 0, 1)',
  },
  gray,
  blue,
  orange,
  green,
  red,
};

const darkPalette = {
  mode: 'dark',
  primary: {
    main: 'rgba(144, 202, 249, 1)',
    light: 'rgba(227, 242, 253, 1)',
    dark: 'rgba(66, 165, 245, 1)',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  secondary: {
    main: 'rgba(38, 166, 154, 1)',
    light: 'rgba(178, 223, 219, 1)',
    dark: 'rgba(0, 137, 123, 1)',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  info: {
    main: 'rgba(41, 182, 246, 1)',
    light: 'rgba(79, 195, 247, 1)',
    dark: 'rgba(2, 136, 209, 1)',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  success: {
    main: 'rgba(102, 187, 106, 1)',
    light: 'rgba(129, 199, 132, 1)',
    dark: 'rgba(56, 142, 60, 1)',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  warning: {
    main: 'rgba(255, 167, 38, 1)',
    light: 'rgba(255, 183, 77, 1)',
    dark: 'rgba(245, 124, 0, 1)',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  error: {
    main: 'rgba(244, 67, 54, 1)',
    light: 'rgba(229, 115, 115, 1)',
    dark: 'rgba(211, 47, 47, 1)',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  background: {
    paper: 'rgba(18, 18, 18, 1)',
    default: 'rgba(18, 18, 18, 1)',
  },
  other: {
    rating: 'rgba(255, 180, 0, 1)',
    snackbar: 'rgba(50, 50, 50, 1)',
  },
  gray,
  blue,
  orange,
  green,
  red,
};

module.exports = {
  lightPalette,
  darkPalette,
};
